import { Alert, Button, Card, CardContent, Container, TextField, Typography } from '@mui/material';
import React, { FormEvent, useState } from 'react';
import { CTM_Colors } from '../Helper';
import pb from '../pocketBase';

const Login = ({ onLoginSuccess }: any) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isLoading) return;
        setError('');
        setIsLoading(true);
        try {
            const authData = await pb.collection('users').authWithPassword(email, password);
            onLoginSuccess(authData); // notify the parent component
        } catch (err) {
            setError('Invalid email or password. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <Card
                sx={(theme) => ({
                    width: '100%', 
                    padding: 3, 
                    boxShadow: 3, 
                    backgroundColor: theme.palette.mode === 'dark' ? CTM_Colors.dark_grey : '#f9f9f9',
                })}
            >
                <CardContent>
                    <Typography variant="h5" component="h2" gutterBottom textAlign="center">
                        Login
                    </Typography>
                    <form onSubmit={handleLogin}>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Email"
                            variant="outlined"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Password"
                            variant="outlined"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                        <Button type="submit" variant="contained" color="primary" fullWidth disabled={isLoading} sx={{ mt: 2, backgroundColor: CTM_Colors.ctm_green }}>
                            {isLoading ? 'Logging in...' : 'Login'}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </Container>
    );
};

export default Login;